/*-------------------------------------------------------------------------
 * 作者：dongchunshui
 * 创建时间： 2017/7
 * 版本号：v1.0
 * 作用域：交易记录
 -------------------------------------------------------------------------*/
(function () {
  var isMoreThanLimitAccessCount = "/wealth/record/needcaptcha";//查询交易记录，监测是否需要验证码
  var getWealthJournal = "/wealth/record/journal";//交易记录，分页查询
  var wealthUrl = "/wealth/user/wealth";//获取金银符数量
  var sliverlistUrl = '/wealth/sliver/sliverlist';//新增内容，获取账号发奖列表
  var daoTradeChinaCaptcha = null;//验证码创建
  var getIngotUrl = '/wealth/buyYinfu/buyyuanbao'; //领取银元宝
  var that = null;
  var checkNumList = 0;
  let startDate = '';
  let endDate = '';
  var yinyuanbaoStr = '' +
    '<div class="buyyuanbao_con"  id="js_buyyuanbao">' +
    '<i class="js_close cursor closeD"></i>' +
    '<div class="tab_title">' +
    '<ul class="js_money_tab">' +
    '<li data-cur="false" class="on">领取银元宝</li>' +
    '</ul>' +
    '</div>' +
    '<div class="tab_con js_tab_con">' +
    '<div class="p m_t_24">' +
    '<label class="tag_title">游戏账号：</label>' +
    '<input type="text" class="text_input js_getAccount" placeholder="请填写游戏账号" maxlength="20">' +
    '</div>' +
    '<div class="p m_t_24">' +
    '<label class="tag_title">确认账号：</label>' +
    '<input type="text" class="text_input js_confirmAccount" placeholder="请填写确认账号" maxlength="20">' +
    '</div>' +
    '<div class="p rules m_t_24">' +
    '<input type="checkbox" id="ingot_accept" checked="true"/>' +
    '<label for="guld_accept">同意</label>' +
    '<a target="_blank" href="//kf.gyyx.cn/home/agreement?3">光宇玩家守则</a>' +
    '</div>' +
    '<div class="p sub_btn m_t_12">' +
    '<div class="js_ingot_captcha_wrap"></div>' +
    '<div class="form_error js_form_ingot_error"></div>' +
    '<a class="js_ingot_getBtn silverChangeBtn" data-status="true">领 取</a>' +
    '</div>' +
    '<div class="p rules notice m_t_24"><label>若出现支付异常，请您联系光宇在线客服</label><a target="_blank" href="//kf.gyyx.cn/Home/IMIndex">光宇在线客服</a></div>' +

    '</div>' +
    '</div>';
  var tradeStr = '' +
    '<div class="js_tradePop" id="js_tradePop">' +
    '<i class="js_close cursor closeD"></i>' +
    '<div class="con">' +
    '<div class="payTit">' +
    '<span class="jyjl js_tabTitle lf on">交易记录</span>' +
    '<span class="jyjl js_tabTitle lf">订单状态</span>' +
    '<p class="yF ri">' +
    '<span class="c4">银符钱</span>' +
    '<i class="js_wealthYf">***</i>' +
    '</p>' +
    '<p class="jF ri">' +
    '<span class="c3">金符钱</span>' +
    '<i class="js_wealthJf">***</i>' +
    '</p>' +
    '</div>' +
    '<div class="js_tabTradeContent tabTradeContent">' +
    '<div class="typeQuery js_tabContent">' +
    '<div class="cx">' +
    '<span parm="jinfu" class="sel lf jfq active">金符钱</span>' +
    '<span parm="yinfu" class="sel lf yfq">银符钱</span>' +
    '<span class="tis lf">时间&nbsp;&nbsp;:&nbsp;&nbsp;</span>' +
    '<select class="selTimes lf">' +
    '<option value="301707">2017年7月</option>' +
    '</select>' +
    '<span class="js_cx ri">查询</span>' +
    '</div>' +
    '<div class="pageBox">' +
    '<table border="0" cellspacing="0" cellpadding="0" id="jxTable">' +
    '<thead>' +
    '<tr>' +
    '<th>订单号</th>' +
    '<th>交易类型</th>' +
    '<th>交易金额</th>' +
    '<th>余额</th>' +
    '<th>交易状态</th>' +
    '<th>时间</th>' +
    '</tr>' +
    '</thead>' +
    '<tbody class="pageDiv">' +
    '</tbody>' +
    '</table>' +
    '<p class="notContent hide">无数据</p>' +
    '<div class="page js_page" style="display:none">' +
    '<ul class="pageMenu clearfix">' +
    '<li class="prevPage"> 上一页 </li>' +
    '<div class="pageObj ">' +
    '</div>' +
    '<li class="nextPage"> 下一页  </li>' +
    '</ul>' +
    '</div>' +
    '</div>' +
    '<p class="jlTiShi">若您需要查询3个月前的交易记录，请您联系<a href="//kf.gyyx.cn/Home/IMIndex"  target="_blank" >光宇在线客服</a></p>' +
    '</div>' +
    '<div class="typeQuery js_tabContent" style="display: none;">' +
    '<div class="cx">' +
    '<span class="tis lf">时间&nbsp;:&nbsp;&nbsp;</span>' +
    '<input class="selectDate lf" type="date" id="firstdate" name="date" />' + 

    '<span class="tis lf">&nbsp;&nbsp;至&nbsp;:&nbsp;&nbsp;</span>' +
    '<input class="selectDate lf" type="date" id="lastdate" name="date" />' + 
    // '<select class="selStateTimes lf">' +
    // '<option value="301707">2017年7月</option>' +
    // '</select>' +
    '<span class="tis lf zhuangtai" style="margin-left: 10px">状态&nbsp;&nbsp;:&nbsp;&nbsp;</span>' +
    '<select class="state lf">' +
    '<option value="all">全部</option>' +
    '<option value="pass">已通过</option>' +
    '<option value="inreview">审核中</option>' +
    '<option value="awarded">已兑换</option>' +
    '<option value="unpass">未通过</option>' +
    '<option value="revoke">已撤销</option>' +
    '</select>' +
    '<span class="js_state ri">查询</span>' +
    '</div>' +
    '<div class="pageBoxstatus">' +
    '<table border="0" cellspacing="0" cellpadding="0" id="statusTable">' +
    '<thead>' +
    '<tr>' +
    '<th><input type="checkbox" class="allcheckbox" name="checkbox"></th>' +
    '<th>申请管理员</th>' +
    '<th>金额数</th>' +
    '<th>订单号</th>' +
    '<th>申请时间</th>' +
    '<th>状态</th>' +
    '<th>帖子id</th>' +
    '</tr>' +
    '</thead>' +
    '<tbody class="pageDiv">' +
    '</tbody>' +
    '</table>' +
    '<p class="notContent hide">无数据</p>' +
    '<button class="js_duihuanbtn duihuanbtn">兑换</button>'+
    '<footer class="footer bg-white b-t">' +
    '<div class="row dataTables_wrapper1">' +
    '<div id="tieInfo_Table_0_info1" ></div>' +
    '<div id="tieInfo_Table_0_paginate1"></div>' +
    '</div>' +
    '</footer>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>';
  function Wealth_trade() {
    //函数块
  }
  Wealth_trade.prototype = {
    init: function () {
      var _this = that = this;
      //初始化短信类型
      daoTradeChinaCaptcha = configCaptcha({
        captchaInWrap: ".js_configCaptchaPopIn",//内嵌验证码容器（简单，复杂）
        cssLinkSrc: "//s.gyyx.cn/Lib/configCaptcha/css/configCaptcha.min.css",
        data: { //参数
          bid: "wbheanyerpbeq"//区分不同业务 非空
        },
        isCaptchaOnePop: true, //简单、复杂验证码都在弹层显示
        comIn: false, //复杂验证码是否内嵌 true:内嵌  false：弹层
        isOpenCaptcha: false,//是否需要验证码开关(部分业务需求需要开启 如：登录)
        inputaccName: "Account", //自定义隐藏域name名称
        inputName: "tradeCaptcha",//自定义账号name名称(失去焦点时验证是否需要验证码)
        inputCookieName: "tradeCookies"//自定义隐藏域cookie name名称
      });
      daoTradeChinaCaptcha.init();//初始化验证码
      // 添加交易记录框
      $(document.body).append(tradeStr);
      // 添加领取银元宝框
      $(document.body).append(yinyuanbaoStr);
      $("#js_tradePop").popD({
        width: "760px",
        height: "700px"
      });
      $("#js_buyyuanbao").popD({
        width: "760px",
        height: "700px"
      });
      _this.tradeClickFn();
      _this.getStateFn();
      _this.selectOrderDateFn();
    },
    // 日期
    selectOrderDateFn: function () {
      
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      
      let month = currentDate.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      
      let day = currentDate.getDate();
      day = day < 10 ? '0' + day : day;
      
      const startFormattedDate = year + '-' + month + '-01';
      const formattedDate = year + '-' + month + '-' + day;
      document.getElementById('firstdate').value = startFormattedDate;
      document.getElementById('lastdate').value = formattedDate;
      document.getElementById('lastdate').setAttribute('max', formattedDate);
      document.getElementById('firstdate').setAttribute('max', formattedDate);
      startDate = startFormattedDate;
      endDate = formattedDate;



      var firstdate = document.getElementById("firstdate");
      var lastdate = document.getElementById("lastdate");
      firstdate.addEventListener('change', function() {
          console.log(this.value); // 输出选择的日期值
          startDate = this.value;
          // document.getElementById('lastdate').setAttribute('min', startDate);
      });
      lastdate.addEventListener('change', function() {
        console.log(this.value); // 输出选择的日期值
        endDate = this.value;
    });
    },
    //点击交易记录按钮
    tradeClickFn: function () {
      var _this = this;
      $(".js_tradRecord").on("click", function () {
        $("#infoEdit .nickname").prop("disabled", true).removeClass("nicknameTextBorder");
        // 防重复点击
        // if ($(this).attr("data-status") == "false") {
        //     return false;
        // }
        // $(this).attr("data-status", "false");
        // 验证登录状态
        global_main.globalFn.checkLoginStatus(function (d) {
          if (d.data.nickname) {
            _this.showTradePop();//展示交易弹层
          } else {
            login_main.settingNickPop();
            // $(".tc02").hide();
            // $(".js_tradRecord").attr("data-status", "true");
          }
        })

      })
    },
    // 查询订单记录
    getStateFn: function () {
      var _this = this;
      $(".js_state").on("click", function () {
        _this.getDingdanStatusListFn();
      });
    },

    //展示交易弹层
    showTradePop: function () {
      var _this = this;
      // 展示交易记录弹层
      // if (!$(".js_tradePop").length) {
      //     $("body").append(tradeStr);
      // }
      // 交易记录弹框展示
      $("#js_tradePop").popD("open");
      _this.wealthAjaxFn();//获取金银付钱
      // _this.closeLogin(".js_tradePop .js_close");//关闭交易记录弹层
      _this.closeLogin(".js_tradePop .js_close");//关闭交易记录弹层
      // tab切换,交易记录选项卡切换
      _this.tabClickFn();
    },
    /**
     * @function tab切换,交易记录选项卡切换
     * @name tabClickFn
     */
    tabClickFn: function () {
      var _this = this;
      _this.choosePayForYarMou();//交易记录的时间查询年月选择
      _this.isMoreThanLimitAccessCount();//获取交易记录列表,有验证，原逻辑，超过五次会有验证码弹出
      _this.searchFn();//查询交易记录
      _this.trailEventFn()//后续事件
      //默认显示交易记录数据信息
      $(".js_tabTitle").parents(".js_tradePop").find(".js_tabTitle").removeClass("on");
      $(".js_tabTitle").eq(0).addClass("on");
      $(".js_tabTradeContent .js_tabContent").eq(0).show().siblings().hide();

      $(".js_tabTitle").off("click").on("click", function () {
        $(".js_tabTradeContent .js_tabContent").eq($(this).index()).show().siblings().hide();
        if (!$(this).hasClass("on")) {
          $(this).parents(".js_tradePop").find(".js_tabTitle").removeClass("on");
          $(this).addClass("on");
          if ($(this).index() === 0) {
            _this.choosePayForYarMou();//交易记录的时间查询年月选择
            _this.searchFn();//查询交易记录
            _this.trailEventFn()//交易记录后续事件
          } else {
            // 查询订单状态列表接口
            _this.getDingdanStatusListFn();

          }
        }

      })
    },
    /**
     * @function 订单状态
     * @name getDingdanStatusListFn
     * */
    getDingdanStatusListFn: function () {
      var _this = this;
      // var tim = $(".cx .selStateTimes option:selected").attr("sp").split(",");
      var state = $(".cx .state option:selected").val();
      $(".pageBoxstatus .pageDiv").ajaxPage({
        url: sliverlistUrl,
        type: "GET",
        pageObj: $("#tieInfo_Table_0_paginate1"),
        pageIndex: 1,
        pageSize: 7,
        curPageCls: "paginate_activetrade",
        pageInfo: {
          obj: $("#tieInfo_Table_0_info1"),
          content: ""
        },
        paramObj: {
          r: Math.random(),
          startDate: startDate,
          endDate: endDate,
          status: state,
        },
        dataFn: function (d) {
          var data = d.data
          var dataHtml = "";
          checkNumList = 0;
          $('.allcheckbox').prop('checked', false)
          if (data && data.length > 0) {
            $(".dataTables_wrapper1").show();
            for (var i = 0; i < data.length; i++) {
              var dateTime = that.formatDate(data[i].applyTime);
              var applyStatus = "";//申请状态
              switch (data[i].applyStatus) {
                case "revoke"://已撤销
                  applyStatus = "已撤销";
                  break;
                case "pass"://已通过
                  applyStatus = "已通过";
                  break;
                case "unpass"://未通过
                  applyStatus = "未通过";
                  break;
                case "awarded"://已兑换
                  applyStatus = "已兑换";
                  break;
                case "inreview"://审核中
                  applyStatus = "审核中";
                  break;
              }
              dataHtml += '<tr>';
              if (data[i].applyStatus !== "pass") {
                dataHtml += '<td><input disabled data-item='+ data[i].orderNo +' type="checkbox" name="checkbox"></td>';
              }else {
                checkNumList += 1;
                dataHtml += '<td><input class="clickExchange " data-item='+ data[i].orderNo +' type="checkbox" name="checkbox"></td>';
              }
                
              dataHtml += '<td><span class="ellipsisTxt">' + data[i].applier + '</span></td>' +
                '<td>' + data[i].totalAmount + '</td>' +
                '<td class="js_orderNo">' + data[i].orderNo + '</td>' +
                '<td>' + dateTime + '</td>' +
                '<td class="sourceTimes">' + applyStatus + '</td>' +
                '<td>' + data[i].threadId + '</td>' +
                '</tr>';
            }

          } else {
            dataHtml = "<tr><td class='notContent' colspan=7>暂无数据~</td></tr>"
          }
          $(".pageBoxstatus .pageDiv").html(dataHtml);
          return dataHtml;

        },
        successFn: function () {
          // 点击兑换按钮弹出兑换弹层
          _this.buyyuanbaoClickBtn();
          _this.clickExchange();
        }
      });

    },

    //多选兑换
    clickExchange: function () {
      $(".clickExchange").off("click").on("click", function () {
        if ($(".clickExchange[type='checkbox']:checked").length !== checkNumList) {
          $(".allcheckbox").prop('checked', false)
        }else {
          $(".allcheckbox").prop('checked', true)
        }
      })

      $('.allcheckbox').off("click").on("click", function () {
        $(".clickExchange").prop('checked', $(this).prop('checked'))
       })

    },

    //点击兑换按钮弹出兑换弹层来
    buyyuanbaoClickBtn: function () {
      var _this = this;
      $(".js_duihuanbtn").off("click").on("click", function () {
        let orderList = [];
        // 获取订单号
        const checkOrderNum = $(".clickExchange[type='checkbox']:checked");
        if (checkOrderNum.length === 0) {
          $(document).popErrorF({ type: "open", tip: "请选择兑换订单" });
        }else {
          checkOrderNum.each(function() {
            orderList.push($(this).attr('data-item'));
          });
          // 展示兑换弹层
          $("#js_tradePop").popD("close");//关闭交易记录弹框
          $("#js_buyyuanbao").popD("open");//打开领取元宝弹层
          $(".js_money_tab").attr("data-orderNum",orderList);
          //银元宝
          _this.getIngotFn();
          //领取银元宝验证码
          _this.ingotCaptchaFn();
        }
       
      })

    },

    //提交领取银元宝表单
    getIngotFn: function () {
      var _this = this;
      $(".js_ingot_getBtn").click(function () {

        var checked = $("#ingot_accept:checked").length;

        // var theNum = $('.js_getNum').val();
        // var numExp = new RegExp('^[1-9]\\d{0,}$');

        var getAccount = $('.js_getAccount').val();

        var confirmAccount = $('.js_confirmAccount').val();


        if (!checked) {

          _this.setErrorTipFn($(".js_form_ingot_error"), "请勾选玩家守则");

        } else if ($.trim(getAccount) === '') {

          _this.setErrorTipFn($(".js_form_ingot_error"), "游戏账号不能为空");

        } else if ($.trim(confirmAccount) === '') {

          _this.setErrorTipFn($(".js_form_ingot_error"), "确认账号不能为空");

        } else if ($.trim(getAccount).toLowerCase() !== $.trim(confirmAccount).toLowerCase()) {

          _this.setErrorTipFn($(".js_form_ingot_error"), "两次输入的账号不一致，请重新填写");

        } else {
          _this.setErrorTipFn($(".js_form_ingot_error"), "");

          chinaCaptchaGetIngot.openCaptchaOnePop(_this.getIngotFormAjaxFn);//显示弹层中文验证码
          login_main.popLevelFn(".configCaptchaPopWrap", ".configCaptchaMask", 2002000, 1003000);//遮罩弹层层级设置


        }
      });
    },
    //领取银元宝表单提交ajax
    getIngotFormAjaxFn: function () {
      var ordernum=$(".js_money_tab").attr("data-orderNum");
      $.ajax({
        url: getIngotUrl,
        type: "post",
        dataType: "json",
        data: {
          account: $.trim($('.js_getAccount').val()),
          orderNo: ordernum,//兑换单号
          validateCode: $('input[name="js_ingot_yzm"]').val(),
          cookieValue: $('input[name="js_ingot_cookies"]').val(),
          r: Math.random()
        },
        success: function (d) {

          if (d.status == "success") {
            chinaCaptchaGetIngot.closeCaptchaPop();//关闭复杂验证码
            $("#recharge").popD("close");  //关闭充值弹层
            $(document).popSuccF({
              type: "open",
              tip: "领取成功",
              countDownStatus: true,
              countDownCloseFn: function () {
                window.location.reload();//刷新页面
              },
              closeFn: function () {
                window.location.reload();//刷新页面
              }
            });
          } else {
            if (d.status == "incorrect-login") {
              chinaCaptchaGetIngot.closeCaptchaPop();//关闭复杂验证码
              $(document).reLoginFn();
            } else if (d.status == "incorrect-nickName") {  //无昵称
              chinaCaptchaGetIngot.closeCaptchaPop();//关闭复杂验证码
              login_main.settingNickPop();
            } else if (d.status == 'validateCodeError') {
              chinaCaptchaGetIngot.callbackCaptchaErrorFn(true); //验证码错误提示
              chinaCaptchaGetIngot.refreshCaptcha($(".js_configCaptchaPopIn"));//刷新验证码
            } else {
              chinaCaptchaGetIngot.closeCaptchaPop();//关闭复杂验证码
              $(document).errorDataOperateFn(d);


            }
          }
        },
        error: function () {
          chinaCaptchaGetIngot.closeCaptchaPop();//关闭复杂验证码
          $(document).popErrorF({ type: "open", tip: "程序小哥打盹儿了，刷新页面试试！" });
        }
      });
    },
    //领取银元宝验证码
    ingotCaptchaFn: function () {
      chinaCaptchaGetIngot = configCaptcha({
        captchaInWrap: ".js_ingot_captcha_wrap",//内嵌验证码容器（简单，复杂）
        data: { //参数
          bid: "duihuanyinyuanbao"//区分不同业务 非空
        },
        isCaptchaOnePop: false, //简单、复杂验证码都在弹层显示
        comIn: false, //复杂验证码是否内嵌 true:内嵌  false：弹层
        isOpenCaptcha: false,//是否需要验证码开关(部分业务需求需要开启 如：登录)
        inputaccName: "Account", //自定义隐藏域name名称
        inputName: "js_ingot_yzm",//自定义账号name名称(失去焦点时验证是否需要验证码)
        inputCookieName: "js_ingot_cookies"//自定义隐藏域cookie name名称
      });
      chinaCaptchaGetIngot.init();

    },
    //查询交易记录操作
    searchFn: function () {
      var _this = this;
      $(".js_cx").on("click", function () {
        if ($(this).attr("keeprepeat") == "false") {
          return false;
        }
        $(this).attr("keeprepeat", "false");
        _this.isMoreThanLimitAccessCount();
      });
    },
    //交易记录后续事件，单选框操作事件
    trailEventFn: function () {
      $(".cx .sel").click(function () {
        $(this).siblings(".sel").removeClass("active").end().addClass("active");
      });
    },
    //关闭弹层
    closeLogin: function (closeBtn) {
      $(document).on("click", closeBtn, function () {
        $(".cx .sel:eq(0)").addClass("active").siblings().removeClass("active");
        $("#js_tradePop").popD("close");//关闭交易记录弹框
        // $("#infoEdit .nickname").prop("disabled", false);
        // $(this).parents(".js_tradePop").hide();
        // $(".bgT").hide();
        // $(".js_tradRecord").attr("data-status", "true");
        // $(".cx .sel:eq(0)").addClass("active").siblings().removeClass("active");
        // $(".pageBox .pageDiv").html("");
      })
    },
    //时间转换
    formatDate: function (nS) {
      var date = new Date(nS),
        Y = date.getFullYear() + '/',
        M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/',
        D = date.getDate(),
        H = date.getHours() + ':',
        Mi = date.getMinutes();
      if (D < 10) {
        D = "0" + D;
      }
      if (Mi < 10) {
        Mi = "0" + Mi;
      }
      return Y + M + D + "&nbsp;" + H + Mi;
    },
    //获取当月天数
    getLastDay: function (year, month) {
      var new_year = year;    //取当前的年份
      var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）
      if (month > 12)            //如果当前大于12月，则年份转到下一年
      {
        new_month -= 12;        //月份减
        new_year++;            //年份增
      }
      var new_date = new Date(new_year, new_month, 1);                //取当年当月中的第一天
      var date_count = (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate();//获取当月的天数
      return date_count;
    },
    //关闭验证码弹层
    captchaCloseFn: function (obj) {
      $(".js_configCaptcha_close").on("click", function () {
        obj.attr("keepRepeat", "true");
      });
    },
    //交易记录的时间查询年月选择
    choosePayForYarMou: function () {
      var _this = this;
      var options = "";
      var tadatCent = new Date();
      var atYear = tadatCent.getFullYear();
      var atMouth = tadatCent.getMonth() + 1;
      var allDays = _this.getLastDay(atYear, atMouth);
      var endK = 0;
      for (var i = 0; i < 3; i++) {
        if (atMouth - i == 0) {
          var sy = 3 - i;
          atMouth = 12
          atYear -= 1;
          allDays = _this.getLastDay(atYear, atMouth);
          for (var k = 0; k < sy; k++) {
            if (endK < 3) {
              endK++
              if (atMouth < 9) {
                options += '<option sp="' + atYear + '-0' + (atMouth - k) + '-01,' + atYear + '-0' + (atMouth - k) + '-' + allDays + '">' + atYear + '年' + (atMouth - k) + '月</option>';
              } else {
                options += '<option sp="' + atYear + '-' + (atMouth - k) + '-01,' + atYear + '-' + (atMouth - k) + '-' + allDays + '">' + atYear + '年' + (atMouth - k) + '月</option>';
              }
            }
          }
        } else {
          if (endK < 3) {
            endK++
            if (atMouth < 9) {
              options += '<option sp="' + atYear + '-0' + (atMouth - i) + '-01,' + atYear + '-0' + (atMouth - i) + '-' + allDays + '">' + atYear + '年' + (atMouth - i) + '月</option>';
            } else {
              options += '<option sp="' + atYear + '-' + (atMouth - i) + '-01,' + atYear + '-' + (atMouth - i) + '-' + allDays + '">' + atYear + '年' + (atMouth - i) + '月</option>';
            }
          }
        }

      }
      $(".cx .selTimes").html(options);
      $(".cx .selStateTimes").html(options);
    },
    //查询交易记录，监测是否需要验证码
    isMoreThanLimitAccessCount: function () {
      var _this = this;
      $.ajax({
        url: isMoreThanLimitAccessCount,
        type: "get",
        dataType: "JSON",
        data: {
          r: Math.random()
        },
        success: function (res) {
          if (res.status == "true") {
            //新验证码获取时用到
            if (daoTradeChinaCaptcha.captcahSwitchOpen != -1) {
              daoTradeChinaCaptcha.openCaptchaOnePop(_this.getPageForPays);
              _this.captchaCloseFn($(".js_cx"))
              //调整验证码层级样式,第一个弹框，第二个参数是遮罩层
              login_main.popLevelFn(".configCaptchaPopWrap", ".configCaptchaMask", 2002000, 1003000);
            } else {
              _this.getPageForPays();//无验证码时执行
            }

          } else if (res.status == "false") {
            _this.getPageForPays();
          } else {
            //未登录异常处理
            $(document).errorDataOperateFn(res);
            $(".tc02").hide();
          }
        }
      });

    },

    //交易记录，分页查询
    getPageForPays: function () {
      $(".pageBox .pageDiv,.pageBox .pageObj ").html("");
      var tim = $(".cx .selTimes option:selected").attr("sp").split(",");
      //新验证码获取时用到
      var isNeedChpta = daoTradeChinaCaptcha.captcahSwitchOpen;
      var verifyCodes = isNeedChpta != -1 ? $("input[name='tradeCaptcha']").val() : "";
      var cookieValue = isNeedChpta != -1 ? $("input[name='tradeCookies']").val() : "";

      $(".pageBox").pageFun({
        interFace: getWealthJournal,
        displayCount: 5,  //每页显示总条数
        maxPage: 6,  //每次最多加载多少页
        paramObj: { //传参
          currencyType: $(".cx .active").attr("parm"),//货币类型
          cookieValue: cookieValue,//验证码cookieValue，新验证码获取时用到
          validateCode: verifyCodes,//验证码，新验证码获取时用到
          startDate: tim[0],
          r: Math.random(),
          endDate: tim[1]
        },
        dataFun: function (data) {
          var dataHtml = "";
          if (data) {
            var dateTime = that.formatDate(data.createTime)
            dataHtml = '<tr>' +
              '<td><span title=' + data.sourceOrderNo + ' class="ellipsisTxt">' + data.sourceOrderNo + '</span></td>' +
              '<td>' + data.sourceType + '</td>' +
              '<td>' + data.amount + '</td><td>' + data.balance + '</td><td>成功</td>' +
              '<td class="sourceTimes">' + dateTime + '</td></tr>';
            $(".js_cx").attr("keepRepeat", "true");
          }
          return dataHtml;
        },
        pageFun: function (i) {
          var pageHtml = '<li class="pageNum">' + i + '</li>';
          return pageHtml;
        }

      });

    },
    //获取金银符数量
    wealthAjaxFn: function () {
      $.ajax({
        url: wealthUrl,
        type: "GET",
        dataType: "json",
        data: {
          r: Math.random()
        },
        success: function (d) {
          if (d.status == "success") {
            //金银付钱展示位
            $(".js_wealthJf").html(d.data.jinfu);
            $(".js_wealthYf").html(d.data.yinfu);
          } else {
            //未登录异常处理
            $(document).errorDataOperateFn(d);
            $(".tc02").hide();
          }
        }
      });
    },
    //错误提示
    setErrorTipFn:function(obj,str){
      obj.text(str);
    }
  };
  window.Wealth_trade = function () {
    return new Wealth_trade();
  };
})();
$(function () {
  Wealth_trade().init();
});